import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import moment from "moment/moment";
import LoaderCircle from "../../../loader/LoaderCircle";
import LastRequestIcon from "../../../icons/LastRequestIcon";
import StoreController from "../../../../stories/_client/Stores/StoreController";
import AppContext from "../../../../context/AppContext";

const LastRequests = () => {
	const { setEvent, setBubbleText } = useContext(AppContext);
	const [ list, setList ] = useState([]);
	const [ loading, setLoading ] = useState(true);

	const refresh = () => {
		const controller = new StoreController();
		controller._callback = handleRefresh;
		controller.listRequests();
	}
	const handleRefresh = (list, error, pagination, status) => {
		setLoading(false);

		switch (status) {
			case 200:
				setList(list);
				break;
			default:
				setEvent({
					type: "error",
					text: "Une erreur s'est produite lors du chargement des dernières requêtes de création"
				});
				break;
		}
	}

	useEffect(() => {
		refresh();
	}, []);

    return (
        <div className="block lastViewed">
			<div className={"containerTitle"}>
				<LastRequestIcon />
				<p>Dernières demandes de création</p>
			</div>
			<div className={"list"}>
				{
					loading
						? <LoaderCircle display="loader loadingDashboard" strokeWidth="8" stroke="#006D3E" />
						: (
							list.length > 0
								? list.map((request, index) => (
									<Link key={index} to={ "/clients/new/" + request.id }>
										<div key={index} className={"elmt"}>
											<p className={"text"}>{ request.name }</p>
											<p className={"since"}>Il y a { moment(request.created_at).fromNow(true) }, par { request.creator_name }</p>
										</div>
									</Link>
								))
								: <div className={"elmt empty"}><p className={"text empty"}>Aucune demande</p></div>
						)
				}
			</div>
		</div>
    )
}

export default LastRequests;
